var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 30,
    fill: "none",
    className: "social-link"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.3 0h4.97L20.42 12.4l12.76 16.85h-9.99l-7.82-10.22-8.95 10.22H1.45L13.05 16 .82 0h10.24l7.06 9.35L26.3 0Zm-1.74 26.3h2.75L9.56 2.82H6.61l17.95 23.47Z"
  })));
};
export default SvgTwitter;